__turbopack_context__.v({
  "bannerCopy": "ChatbotsTrialBanner-module__-YNLWq__bannerCopy",
  "bannerHeader": "ChatbotsTrialBanner-module__-YNLWq__bannerHeader",
  "buttons": "ChatbotsTrialBanner-module__-YNLWq__buttons",
  "planLink": "ChatbotsTrialBanner-module__-YNLWq__planLink",
  "wrapper": "ChatbotsTrialBanner-module__-YNLWq__wrapper",
});
